<template>
<section class="pageHead section pretty-bottom" :class="[isMainTab ? 'landingHead': 'subpageHead', currentTab]">
  <!-- why need v-if here? without it, the filter will be shown half way, as the images are loaded after the filter created,
    so the filter doesn't have the right size -->
  <div v-if="photoCollection?.banner?.length && isMainTab" class="headBg backdrop-blur" :class="[currentTab]" :style="{backgroundImage}"></div>
  <div class="container is-fluid">
    <div class="columns is-desktop">
      <!-- left side banner contents -->
      <div class="speciesIntro column is-7-desktop">
        <div class="contentWrap">

          <a v-if="false && !isMainTab && tabs.alberta" @click="switchTab('alberta')" class="backLink link">
            <svg class="arrowLeft">
                <use xlink:href="@/assets/sprite.svg#icon-chevron"></use>
            </svg>
            Back to  {{ tabs.alberta.label }}
          </a>
          <p class="tab-name mb-2"> <span class="pc">  {{ tabs[currentTab]?.label }} </span></p>
          <h1 class="nav-name" v-if="state?.commonName">{{state?.commonName}}</h1>
          <p v-if="state.scientificName !== state.commonName" :class="{'h1': !(state?.commonName), 'altName intro': (state?.commonName)}" class="italic mt-0">
            {{state?.scientificName}}</p>
          <p v-show="currentTab === 'overview'" class="profile richtext" v-html="sppContent?.WebMainDescription"></p>
          <!--  hide when with spp app information, but withou any ab status -->
          <p v-show="displayTaxonInforOnBanner" class="profile richtext" v-html="$t('profile.ABStatus.banner.' + (state?.isBird ? 'birds' : 'otherTaxon'), {speciesGroup: state?.groupName?.toLowerCase()})"></p>

          <p v-show="currentTab === 'osr'" class="profile richtext" v-html="$t('profile.OSRBirdStatus.banner.description', {sppName: state?.sppName})"></p>

          <p v-show="currentTab === 'mammalOsr'" class="profile richtext" v-html="$t('profile.OSRMammalStatus.banner.description', {sppName: state?.sppName})"></p>

          <div class="columns mt-1" v-if="isMainTab">
            <div class="column stats">
              <h3 class="caps">{{ $t("profile.topNav.aboutData") }} </h3>
              <p>
                <span><strong class="cf3 accent">{{ $t("profile.topNav.dataPeriod") }}: </strong>{{state?.sppGroup?.startYear}} - {{state?.sppGroup?.endYear}}</span>
              </p>
              <!--p> <span><strong class="cf3 accent"> {{ $t("profile.topNav.resultYear") }}: </strong> {{state?.sppGroup?.releaseYear}}</span -->
              <p> <span><strong class="cf3 accent"> {{ $t("profile.topNav.resultYearLabel") }}: </strong> {{ $t("profile.topNav.resultYear") }}</span>
              </p>
              <p v-if="state?.isSpecies">
                  <span><strong class="cf3 accent">{{ $t("profile.topNav.dataModel") }}: </strong>{{state?.summaryType}} </span>
              </p>
            </div>
            <div class="column stats is-6-desktop">
              <template v-if="state?.isSpecies &&  guilds && guilds?.length > 0">
                <template v-for="(guild, index) in guilds" :key="'guild' + index">
                  <h3 class="caps">{{ guild.label }} </h3>
                  <p v-for="(guildItem, itemIndex) in guild.data" :key="'guildItem' + itemIndex">
                    <span class="cf3" v-tooltip="guildItem.hover"><b>{{guildItem.label}}</b> </span>: {{guildItem.value}}
                  </p>
                </template>
              </template>
            </div>
          </div>
          <div class="columns mt-1" v-if="currentTab === 'overview'">
            <div class="column stats is-12-desktop">
              <template v-if="state?.isSpecies &&  guilds && guilds?.length > 0">
                <template v-for="(guild, index) in guilds" :key="'guild' + index">
                  <h3 class="caps">{{ guild.label }} </h3>
                  <p v-for="(guildItem, itemIndex) in guild.data" :key="'guildItem' + itemIndex">
                    <span class="cf3" v-tooltip="guildItem.hover"><b>{{guildItem.label}}</b> </span>: {{guildItem.value}}
                  </p>
                </template>
              </template>
            </div>
          </div>
        </div>
      </div>
      <!-- right side image slider -->
      <div class="speciesImg column is-5-desktop">
        <template v-if="!isMainTab">
          <div :class="['rounded-' + (tabIndex%2 + 1)]" class="bannerImage objectFit" v-if="photoCollection?.banner?.length > 0">
            <photo-images :paths="photoCollection?.banner[0]?.path" :class="''" />
          </div>
        </template>
        <div style="height:100%;" v-else>
          <vueper-slides  v-if="photoCollection?.banner?.length > 1">
            <vueper-slide v-for="(image, index) in photoCollection?.banner" :key="'image' + index" class="squareImg " >
              <template #content>
                <div v-if="false" class="bannerImage" :style="{backgroundImage: 'url(' + image.path + ')', position: 'relative'}"></div>
                <div class="objectFit">
                  <photo-images :paths="image.path" :class="''" />
                </div>
              </template>
            </vueper-slide>
          </vueper-slides>
          <template v-else>
            <div class="squareImg objectFit" v-if="photoCollection?.banner?.length > 0">
              <photo-images :paths="photoCollection?.banner[0]?.path" :class="''" />
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
  <div class="downloadButton" v-show="false">
    <a class="button is-primary">Download Full Report</a>
  </div>
</section>
</template>
<script setup>
import { computed } from 'vue';
import { useApp } from '@/composables/state/profileState';
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import PhotoImages from '../../components/biobrowser/PhotoImages.vue';
// import { tabs as initialTabs} from '@/config/profile-config.js';
/**
  When no alberta status information availabel (!hasAnyStatusTabSections),
    hide drop down menu, only show overview
  When no overview to be shown (no content write up for the spp profiles):
    display occurrence map on the alberta overview page.

 */
const { state, guilds, switchTab, currentTab, sppContent, hasSppContent, tabs, photoCollection, hasAnyStatusTabSections } = useApp();

const backgroundImage = computed(() => {
  if (photoCollection['tab-' + currentTab.value] && photoCollection['tab-' + currentTab.value].length > 0 && photoCollection['tab-' + currentTab.value][0]?.path?.length > 0) {
    return `url(${photoCollection['tab-' + currentTab.value][0].path[0]})`;
  }
  return '';
});
/* banner taxon related text displayed:
      1. at status of alberta ta, when there are data
      and
      2. not (at overview tab without status of alberta data, with species app profile content
     */
const displayTaxonInforOnBanner = computed(() => {
  return (currentTab.value === 'alberta' && hasAnyStatusTabSections) || (currentTab.value === 'overview' && (!hasAnyStatusTabSections && !hasSppContent));
});

const isMainTab = computed(() => {
  /* show dark bg when within 'alberta status' tab, or only one tab avaiable */
  return currentTab.value === 'alberta';
})

const tabIndex = computed(() => {
  return Object.keys(tabs.value).findIndex(x => x === currentTab.value)
})

</script>

<style lang="scss" scoped>
.bannerImage {
  background-size: cover;
  // width: 100%;
  // height: 100%;
  background-position: center
}
.squareImg ::v-deep(.carousel__prev) {
  left: 15px;
  background: #cabebe;
}
.squareImg ::v-deep(.carousel__next) {
  right: 15px;
  background: #cabebe;
}

.squareImg ::v-deep( ol) {
  margin-left: 0em!important;
}

div ::v-deep(.vueperslides),
div ::v-deep(.vueperslides__inner),
div ::v-deep(.vueperslides__parallax-wrapper) {
  height: 100%;
}

div ::v-deep(.vueperslides__parallax-wrapper) {
  z-index: 0;
}
@media screen and (min-width:769px) and (max-width:1215px){
  div ::v-deep(.vueperslides__parallax-wrapper) {
    padding-bottom: 120%!important;
  }
}
@media screen and (min-width:1216px){
  div ::v-deep(.vueperslides__parallax-wrapper) {
    padding-bottom: 100%!important;
  }
}
@media screen and (max-width:768px){
  div ::v-deep(.vueperslides__parallax-wrapper) {
    padding-bottom: 100%!important;
  }
}
.subHead {
  margin-left: 10px;
  padding: 2px 0;
  color: #ffffff!important;
}
.subHead svg * {
  fill: white;
}
.v-popper--has-tooltip {
  cursor: help;
}
.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {
    font-family: Domine,serif;
    margin: 0rem 0 1rem;
    line-height: 1.2em;
}
.nav-name {
  margin-bottom: 0px;
  span {
    font-size: 2rem;
    line-height: 1.5rem;
  }
}
main.main section.pageHead {
  &.osr, &.mammalOsr {
      background-color: #dbdbdb;
    }
  .speciesIntro  {
    .tab-name {
      font-family: Montserrat,sans-serif;
      font-size: 2em;
      font-weight: 600;
    }
    .altName.intro {
      line-height: 1rem;
      text-transform: none;
      letter-spacing: .1em;
    }
  }
  .speciesImg .bannerImage.objectFit {
    width: 75%;
  }
}
</style>
